

document.addEventListener("DOMContentLoaded", function () {
  counterComponent().init();
});

function counterComponent() {
  return {
      init() {
          const counters = document.querySelectorAll('.js-counter');
          if (!counters.length) return;

          const observer = new IntersectionObserver((entries) => {
              entries.forEach(entry => {
                  if (entry.isIntersecting) {
                      this.startCounting(entry.target);
                      observer.unobserve(entry.target);
                  }
              });
          }, { threshold: 0.5 });

          counters.forEach(counter => {
              observer.observe(counter);
          });
      },
      startCounting(element) {
        const target = parseFloat(element.getAttribute('data-counter'));
        const hasDecimal = element.getAttribute('data-counter').includes('.');
        let count = 0;
        const increment = target / 100;
        const interval = setInterval(() => {
            count += increment;
            if (count >= target) {
                count = target;
                clearInterval(interval);
            }
            element.textContent = hasDecimal ? count.toFixed(1) : Math.floor(count);
        }, 20);
      }
  }
}
